var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "800px",
    width: "800px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,8h-1V4.6c0-0.7-0.3-1.3-0.9-1.7c-0.6-0.4-1.3-0.4-1.9-0.1L7.6,8.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0 c-0.1,0-0.1,0.1-0.1,0.1C7.1,8.5,7,8.7,7,9c0,0,0,0,0,0c0,0,0,0,0,0v19c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V10C25,8.9,24.1,8,23,8z  M20,4.6V8h-7.4L20,4.6z M19.3,20c-0.7,0.6-1.5,1-2.3,1.2v1.9c0,0.9,0.6,1.7,1.5,1.9c0,0,0,0,0.1,0c0.1,0,0.1,0.1,0.2,0.1 c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1 c-0.1,0.1-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1c-0.1,0-0.2,0.1-0.4,0.1c0,0,0,0,0,0c0,0,0,0,0,0h-4.6c-0.5,0-0.9-0.4-1-0.9 c-0.1-0.5,0.3-1,0.8-1.1c0.9-0.2,1.5-1,1.5-1.9v-1.9c-0.8-0.2-1.6-0.6-2.3-1.2c-1.6-1.4-2.1-3.7-1.3-5.7l1.1-2.7 c0.2-0.4,0.5-0.6,0.9-0.6h5.3c0.4,0,0.8,0.3,0.9,0.6l1.1,2.7C21.4,16.3,20.9,18.6,19.3,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.33c459bfb7765dfc8464cae3711a408b.svg";
export { ForwardRef as ReactComponent };